import React, { useEffect, useState } from "react";
import app from "../firebase-config";
import Swal from "sweetalert2";
import { getDatabase, ref, get, set, push, remove } from "firebase/database";
import { useNavigate } from "react-router-dom";
import Modal from "./Modal"; 

function Inventory() {
  const navigate = useNavigate();
  const [itemsArray, setItemsArray] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [inputValue1, setInputValue1] = useState("");
  const [inputValue2, setInputValue2] = useState("");
  const [inputValue3, setInputValue3] = useState("");
  const [inputValue4, setInputValue4] = useState("");
  const [priceType, setPriceType] = useState("single");
  const [editItem, setEditItem] = useState(null);
  const [smallPrice, setSmallPrice] = useState("");
  const [mediumPrice, setMediumPrice] = useState("");
  const [largePrice, setLargePrice] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(""); 
  const uniqueCategories = [...new Set(itemsArray.map((item) => item.category))];

 // Save new data function
 const saveData = async () => {
  const db = getDatabase(app);
  const dbRef = ref(db, "beverages/coffee");

  // Fetch all existing items to check for duplicates
  const snapshot = await get(dbRef);
  if (snapshot.exists()) {
    const existingItems = snapshot.val();

    // Check if the coffeeName already exists in the database
    const isDuplicate = Object.keys(existingItems).some((key) => {
      return existingItems[key].coffeeName.toLowerCase() === inputValue1.toLowerCase();
    });

    if (isDuplicate) {
      Swal.fire({
        title: "Item already exists!",
        text: "An item with this name already exists!",
        icon: "warning",
        draggable: false,
      });
      return; 
    }
  }

  const newDocRef = push(ref(db, "beverages/coffee"));
  set(newDocRef, {
    coffeeName: inputValue1,
    quantity: inputValue2,
    category: inputValue4,
    priceType: priceType,
    prices: {
      single: inputValue3 || smallPrice,
      small: smallPrice,
      medium: mediumPrice,
      large: largePrice,
    }
  })
    .then(() => {
      Swal.fire({
        title: "Item added successfully",
        icon: "success",
        draggable: false,
      });
      setIsModalOpen(false);
      resetFormFields();
      fetchData();
    })
    .catch((error) => {
      alert(error.message);
    });
};

const handleCategoryChange = (category) => {
  setSelectedCategory(category);
  if (category === "") {
    setFilteredItems(itemsArray);
  } else {
    setFilteredItems(itemsArray.filter(item => item.category === category));
  }
};



  // Reset form fields
  const resetFormFields = () => {
    setInputValue1("");
    setInputValue2("");
    setInputValue3("");
    setInputValue4("");
    setPriceType("");
    setSmallPrice("");
    setMediumPrice("");
    setLargePrice("");
  };

  // Fetching data function
  const fetchData = async () => {
    const db = getDatabase(app);
    const dbRef = ref(db, "beverages/coffee");
    const snapshot = await get(dbRef);
    if (snapshot.exists()) {
      const myData = snapshot.val();
      const tempArray = Object.keys(myData).map((fireId) => {
        return {
          ...myData[fireId],
          itemId: fireId,
        };
      });
  
      // Sort the items alphabetically by coffeeName
      tempArray.sort((a, b) => a.coffeeName.localeCompare(b.coffeeName));
  
      setItemsArray(tempArray);
      setFilteredItems(tempArray);
    } else {
    }
  };

// Handle searching by coffee name and category
const handleSearch = (query) => {
    setSearchQuery(query);
    if (query.trim() === "") {
      setFilteredItems(itemsArray); // If search query is empty, show all items
    } else {
      const filtered = itemsArray.filter((item) => {
        // Check if coffeeName and category exist and then perform the search
        const coffeeNameMatch =
          item.coffeeName && item.coffeeName.toLowerCase().includes(query.toLowerCase());
        const categoryMatch =
          item.category && item.category.toLowerCase().includes(query.toLowerCase());
          
        return coffeeNameMatch || categoryMatch;
      });
      setFilteredItems(filtered);
    }
  };

  // Handle editing an item
  const handleEdit = (item) => {
    setEditItem(item);
    setInputValue1(item.coffeeName);
    setInputValue2(item.quantity);
    setInputValue3(item.price);
    setInputValue4(item.category);
    setIsEditModalOpen(true);
  };

  // Save edited data
  const saveEditedData = async () => {
    const db = getDatabase(app);
    const itemRef = ref(db, "beverages/coffee/" + editItem.itemId);
  
    set(itemRef, {
      coffeeName: inputValue1,
      quantity: inputValue2,
      category: inputValue4,
      priceType: priceType,
      prices: {
        single: inputValue3 || smallPrice,
        small: smallPrice,
        medium: mediumPrice,
        large: largePrice,
      }
    })
      .then(() => {
        Swal.fire({
          title: "Item updated successfully",
          icon: "success",
          draggable: false,
        });
        setIsEditModalOpen(false);
        resetFormFields();
        fetchData();
      })
      .catch((error) => {
        alert(error.message);
      });
  };
  

  // Reset fields on modal close
  const closeAddModal = () => {
    setIsModalOpen(false);
    resetFormFields();
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    resetFormFields();
  };

  const openAddModal = () => {
    setIsModalOpen(true);
    resetFormFields();
  };

  // Handle delete item with confirmation
  const handleDelete = (itemId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const db = getDatabase(app);
        const itemRef = ref(db, "beverages/coffee/" + itemId);
        remove(itemRef)
          .then(() => {
            Swal.fire("Deleted!", "Your item has been deleted.", "success");
            fetchData(); // Refresh data after deletion
          })
          .catch((error) => {
            alert(error.message);
          });
      }
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="container mt-4">
      {/* Search Bar */}
      <div className="mb-4">
        <input
          type="text"
          className="form-control"
          placeholder="Search for items..."
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </div>

      <div className="mb-4">
      <div className="mb-4" style={{ display: "flex", justifyContent: "flex-end" }}>
  <select
    className="form-control"
    value={selectedCategory}
    style={{ width: "500px" }}
    onChange={(e) => handleCategoryChange(e.target.value)}
  >
    <option value="">All Categories</option>
    {uniqueCategories.map((category, index) => (
      <option key={index} value={category}>
        {category}
      </option>
    ))}
  </select>
</div>
    </div>


      <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "20px",
            padding: "20px",
          }}
        >
          {filteredItems.length > 0 ? (
            filteredItems.map((item, index) => (
              <div className="card bg-secondary mb-3" style={{ maxWidth: "300px", width: "100%", padding:"0"}} key={index} >
                <div className="card-header" style={{ width: "100%" }}>
                  <h6 style={{maxWidth:"100%"}}>{item.coffeeName}</h6>
                </div>
                <div className="card-body">
                  <p className="card-text">
                    Quantity: {item.quantity}<br />
                    Category: {item.category}<br />
                    {item.prices && (
                      <>
                        <strong>Prices:</strong><br />
                        {item.prices.small !== item.prices.single && item.prices.single && (
                          <span>Single: ₱{item.prices.single}<br /></span>
                        )}
                        {item.prices.small && <span>Small: ₱{item.prices.small}<br /></span>}
                        {item.prices.medium && <span>Medium: ₱{item.prices.medium}<br /></span>}
                        {item.prices.large && <span>Large: ₱{item.prices.large}<br /></span>}
                      </>
                    )}
                  </p>
                </div>

                <div style={{ marginLeft: "auto", padding:"10px" }}>
                <div class="flex">
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      style={{ marginRight: "10px" }}
                      onClick={() => handleEdit(item)}
                    >
                      <img src="/images/edit.png" style={{ width: 20, height: 20 }} />
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      onClick={() => handleDelete(item.itemId)}
                    >
                      <img src="/images/delete.png" style={{ width: 20, height: 20 }} />
                    </button>
                </div>
                </div>
              </div>
            ))
          ) : (
            <p style={{ textAlign: "center", marginTop: "20px", fontSize: "18px" }}>
              No items found
            </p>
          )}
        </div>
      </div>
      {/* Add Item Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={closeAddModal}
        title="Add Item"
        inputValue1={inputValue1}
        inputValue2={inputValue2}
        inputValue3={inputValue3}
        inputValue4={inputValue4}
        setInputValue1={setInputValue1}
        setInputValue2={setInputValue2}
        setInputValue3={setInputValue3}
        setInputValue4={setInputValue4}
        priceType={priceType}
        setPriceType={setPriceType}
        singlePrice={inputValue3}
        setSinglePrice={setInputValue3}
        smallPrice={smallPrice} 
        setSmallPrice={setSmallPrice}
        mediumPrice={mediumPrice} 
        setMediumPrice={setMediumPrice}
        largePrice={largePrice} 
        setLargePrice={setLargePrice}
        onSave={saveData}
      />


      {/* Edit Item Modal */}
      <Modal
        isOpen={isEditModalOpen}
        onClose={closeEditModal}
        title="Edit Coffee"
        inputValue1={inputValue1}
        inputValue2={inputValue2}
        inputValue3={inputValue3}
        inputValue4={inputValue4}
        setInputValue1={setInputValue1}
        setInputValue2={setInputValue2}
        setInputValue3={setInputValue3}
        setInputValue4={setInputValue4}
        priceType={priceType}
        setPriceType={setPriceType}
        singlePrice={inputValue3}
        setSinglePrice={setInputValue3}
        smallPrice={smallPrice} 
        setSmallPrice={setSmallPrice}
        mediumPrice={mediumPrice} 
        setMediumPrice={setMediumPrice}
        largePrice={largePrice} 
        setLargePrice={setLargePrice}
        onSave={saveEditedData}
      />


      <div style={{ height: "80px" }}></div>
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          backgroundColor: "white",
          padding: "10px",
          boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
        }}
      >
        <button
          type="button"
          className="btn btn-outline-success"
          onClick={openAddModal} // Open "Add Item" modal
        >
          Add item
        </button>
      </div>
    </div>
  );
}

export default Inventory;
